import { deserialize, serialize } from "serializr";
import axiosInstance from "../../../interceptor/axiosInstance";
import { ExamChapterModel } from "../../../models/ExamModels/ChapterModel/chapter.model";
import { PaginationModel } from "../../../models/PaginationModel/pagination.model";
import * as apiRoutes from "../../../routes/routeConstants/apiRoutes";
export class ExamChaptersService {
  static fetchExamChapters(
    queryParams: any,
    onSuccess: Function,
    onError: Function
  ) {
    return axiosInstance
      .get(apiRoutes.EXAM_SUBJECT_CHAPTERS_LIST + queryParams)
      .then((response) => {
        const chapters = deserialize(
          ExamChapterModel,
          response["data"]["exam_chapters"]
        );
        const meta = deserialize(PaginationModel, response["data"]["meta"]);
        onSuccess(chapters, meta);
      })
      .catch((error) => {
        onError(error);
      });
  }
  static updateExamChapter(data: any, onSuccess: Function, onError: Function) {
    const serializeChapter = serialize(ExamChapterModel, data["chapterData"]);
    const payload = { exam_chapter: serializeChapter };
    return axiosInstance
      .put(apiRoutes.EXAM_SUBJECT_CHAPTERS_LIST + `/${data.chapterId}`, payload)
      .then((response) => {
        onSuccess(response);
      })
      .catch((error) => {
        onError(error);
      });
  }
  static createNewExamChapter(
    data: any,
    onSuccess: Function,
    onError: Function
  ) {
    const serializeChapter = serialize(ExamChapterModel, data);
    const payload = { exam_chapter: serializeChapter };
    return axiosInstance
      .post(apiRoutes.EXAM_SUBJECT_CHAPTERS_LIST, payload)
      .then((response) => {
        onSuccess(response);
      })
      .catch((error) => {
        onError(error);
      });
  }
  static deleteExamChapter(id: number, onSuccess: Function, onError: Function) {
    return axiosInstance
      .delete(apiRoutes.EXAM_SUBJECT_CHAPTERS_LIST + `/${id}`)
      .then((response) => {
        onSuccess(response);
      })
      .catch((error) => {
        onError(error);
      });
  }
}
